import { ServiceModalConstant } from '../actions/constants/ServiceModalConstant';
import { AuthConstant } from '../actions/constants/AuthConstant';

const MAX_QUEUE_SIZE = 50;

const initialState = {
    // 모달 표시 상태
    showModal: false,
    modalType: null,           // 'ISSUE_ALERT' | 'NEW_TICKET' | null
    currentAlert: null,

    // 미처리 알림 큐
    pendingAlerts: [],
    pendingCount: 0,
    currentIndex: 0,

    // 사용자 가용성
    assigneeList: [],

    // Issue Manager 설정
    issueManagerIds: [],
    issueManagerList: [],
    issueManagersLoaded: false,

    // 상태
    loading: false,
    error: null,
    lastUpdated: null
};

export const ServiceModalReducer = (state = initialState, action) => {
    switch (action.type) {
        case ServiceModalConstant.SHOW_MODAL: {
            // BUG-014-4: alertData가 null이면 pendingAlerts[0] 사용
            // BUG-014-5: 항상 currentIndex를 0으로 리셋 (가장 오래된 것부터)
            const alertData = action.payload.alertData || state.pendingAlerts[0] || null;
            return {
                ...state,
                showModal: true,
                modalType: action.payload.modalType,
                currentAlert: alertData,
                currentIndex: 0
            };
        }

        case ServiceModalConstant.HIDE_MODAL:
            return {
                ...state,
                showModal: false,
                modalType: null,
                currentAlert: null,
                currentIndex: 0     // BUG-014-5: 리셋
            };

        case ServiceModalConstant.GET_PENDING_ALERTS_SUCCESS: {
            const alerts = action.payload.alerts || [];
            return {
                ...state,
                pendingAlerts: alerts,
                pendingCount: alerts.length,
                currentIndex: 0,
                lastUpdated: Date.now()
            };
        }

        case ServiceModalConstant.GET_PENDING_ALERTS_FAIL:
            return { ...state, error: 'Failed to load pending alerts' };

        case ServiceModalConstant.PROCESS_ALERT_SUCCESS: {
            const processedId = action.payload?.alert?._id;
            const remaining = state.pendingAlerts.filter(a => a._id !== processedId);
            const newIndex = state.currentIndex >= remaining.length
                ? Math.max(0, remaining.length - 1)
                : state.currentIndex;
            return {
                ...state,
                pendingAlerts: remaining,
                pendingCount: remaining.length,
                currentIndex: newIndex,
                showModal: remaining.length > 0 ? state.showModal : false,
                currentAlert: remaining.length > 0 ? remaining[newIndex] : null
            };
        }

        case ServiceModalConstant.NAVIGATE_PREV:
            return {
                ...state,
                currentIndex: Math.max(0, state.currentIndex - 1),
                currentAlert: state.pendingAlerts[Math.max(0, state.currentIndex - 1)] || null
            };

        case ServiceModalConstant.NAVIGATE_NEXT:
            return {
                ...state,
                currentIndex: Math.min(state.pendingAlerts.length - 1, state.currentIndex + 1),
                currentAlert: state.pendingAlerts[Math.min(state.pendingAlerts.length - 1, state.currentIndex + 1)] || null
            };

        case ServiceModalConstant.WS_ISSUE_ALERT: {
            const newAlert = action.payload;
            // Priority와 Assignee가 모두 설정된 티켓은 Pending Alert 제외
            if (newAlert.service?.priority && newAlert.service?.assignee) return state;
            // 중복 방지: serviceId + alertType 조합
            const exists = state.pendingAlerts.some(
                a => a.serviceId === newAlert.serviceId && a.alertType === newAlert.alertType
            );
            if (exists) return state;

            const alertData = {
                _id: newAlert.alertId,
                serviceId: newAlert.serviceId,
                ticketKey: newAlert.ticketKey,
                summary: newAlert.summary,
                alertType: newAlert.alertType,
                level: newAlert.level,
                service: newAlert.service,
                createDate: Date.now()
            };

            let updatedAlerts = [...state.pendingAlerts, alertData];
            // 큐 크기 초과 시 오래된 건 제거
            if (updatedAlerts.length > MAX_QUEUE_SIZE) {
                updatedAlerts = updatedAlerts.slice(updatedAlerts.length - MAX_QUEUE_SIZE);
            }

            // BUG-014-1: 모달이 이미 열려있으면 현재 보는 알림 유지, 큐에만 추가
            if (state.showModal) {
                return {
                    ...state,
                    pendingAlerts: updatedAlerts,
                    pendingCount: updatedAlerts.length
                };
            }

            return {
                ...state,
                pendingAlerts: updatedAlerts,
                pendingCount: updatedAlerts.length,
                showModal: true,
                modalType: 'ISSUE_ALERT',
                currentAlert: alertData,
                currentIndex: updatedAlerts.length - 1
            };
        }

        case ServiceModalConstant.WS_NEW_TICKET:
            return {
                ...state,
                showModal: true,
                modalType: 'NEW_TICKET',
                currentAlert: action.payload
            };

        case ServiceModalConstant.WS_ALERT_RESOLVED: {
            const { serviceId, alertType } = action.payload;
            const remaining = state.pendingAlerts.filter(
                a => !(a.serviceId === serviceId && a.alertType === alertType)
            );
            const newIndex = state.currentIndex >= remaining.length
                ? Math.max(0, remaining.length - 1)
                : state.currentIndex;
            return {
                ...state,
                pendingAlerts: remaining,
                pendingCount: remaining.length,
                currentIndex: newIndex
            };
        }

        case ServiceModalConstant.GET_ASSIGNEE_AVAILABILITY_SUCCESS:
            return { ...state, assigneeList: action.payload.users || [] };

        case ServiceModalConstant.GET_ISSUE_MANAGERS_SUCCESS:
            return {
                ...state,
                issueManagerIds: action.payload.issueManagerIds || [],
                issueManagerList: action.payload.managers || [],
                issueManagersLoaded: true,
            };

        case ServiceModalConstant.GET_ISSUE_MANAGERS_FAIL:
            return { ...state, issueManagersLoaded: true, error: 'Failed to load issue managers' };

        case ServiceModalConstant.SET_ISSUE_MANAGERS_SUCCESS:
            return {
                ...state,
                issueManagerIds: action.payload.issueManagerIds || [],
                issueManagersLoaded: true,
            };

        case ServiceModalConstant.LOADING:
            return { ...state, loading: true };

        case ServiceModalConstant.LOADED:
            return { ...state, loading: false };

        case AuthConstant.LOGOUT:
            return initialState;

        default:
            return state;
    }
};
